import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { NoDataFound } from '../../components/NoDataFound'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useSalesChannelType } from '../../hooks/CompanyConfiguration/useSalesChannelType'
import { useHoliday } from '../../hooks/CompanyConfiguration/useHoliday'


import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'

function Holidays() {
  const { holidays } = useContext(ConfigurationContext)
  const { getAllHolidays, deleteHolidays, BulkUpload, loading, paginate, pdfCsvData } = useHoliday()

  const [searchQuery, setSearchQuery] = useState('')

  // const holidays = salesChannelTypes
  //   ? salesChannelTypes.filter((salesChannelType) => salesChannelType && salesChannelType.name && salesChannelType.name.toLowerCase().includes(searchQuery.toLowerCase()))
  //   : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const noOfPages = paginate && paginate.totalPage
  const handleChange = (event, value) => {
    setPage(value)
  }
  //console.log('SELECTED ITEM : ', selected)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)

  useEffect(() => {
    getAllHolidays({
      page: page,
      limit: 15,
      searchQuery: searchQuery
    })
  }, [page, searchQuery])
  

  return (
    <Layout
      heading="Holidays"
      url={ROUTES.ADD_HOLIDAY}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/add-holiday/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      sampleName = {"holiday_sample"}
      sheetName= 'holidays'
      filename = "holidays"
      tempHeaders = {["description", "date", ]}
      tempHeaderData = {[["New Year's Eve", "2022-12-25"]]}
      headers = {pdfCsvData.headings}
      data = {pdfCsvData.headingValues}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {holidays.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < holidays.length}
                checked={holidays.length > 0 && selected.length === holidays.length}
                onClick={(event) => handleSelectAllClick(event, holidays, setSelected)}
              />,
              'date',
              'description',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            holidays.length > 0 &&
            holidays.map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{formatDate(item.date)}</TableCell>
                   <TableCell>{item.description}</TableCell>
                    {/* <TableCell>{formatDate(item.createdAt)}</TableCell> */}
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => {deleteHolidays({ ids: multipleId }, setSelected)
        window.location.reload()
      }}
      />
      {!loading && holidays.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {loading && <Loader />}
      {!loading && !holidays.length && <NoDataFound />}
    </Layout>
  )
}

export default Holidays
